import FormSectionTitle from '../../../elements/FormSectionTitle'
import useModalShow from '../../../elements/Hooks/useModalShow'
import { get, groupBy } from 'lodash'
import CustomTable from '../../../elements/Table/CustomTable'
import moment from 'moment'
import React, { Fragment } from 'react'
import { Button, Descriptions, Row, Tag } from 'antd'
import EditModal from '../../People/Member/Modal/Profile'

function Profile (props) {
  const { member, repsList, fetch, fetching } = props
  const { visible, onShow, onCancel } = useModalShow()
  const { visible: repVisible, onShow: onShowRep, onCancel: onCancelRep, payload: rep } = useModalShow()

  const columns = [
    { Header: 'ID', accessor: '_id', hideable: true, hideDefault: true },
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({ value, original }) => <a onClick={() => onShowRep(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Position',
      accessor: 'position',
      Cell: ({ value }) => value.split(',').map((i) => <Tag color="#2db7f5">{i}</Tag>),
    },
    { Header: 'Email', accessor: 'email' },
    { Header: 'Phone', accessor: 'phone' },
  ]
  console.log(member)
  const url = Array.isArray(member.url)
    ? member.url.map((p) => (
      <span>
          [{get(p, 'tag[0]')}] {p.value}
        </span>
    ))
    : member.url

  const uniqDataByPosition = Object.values(groupBy(repsList, '_id')).map((i) => ({
    ...i[0],
    position: i.map((j) => j.position).join(', '),
  }))

  return (
    <Fragment>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Descriptions bordered column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Full Name">{member.fn}</Descriptions.Item>
          <Descriptions.Item label="Trading Name">{member.tradeName}</Descriptions.Item>
          <Descriptions.Item label="Website">{url}</Descriptions.Item>
          <Descriptions.Item label="Country">{member.cob}</Descriptions.Item>
          <Descriptions.Item label="Registration Date">
            {moment(member.registrationDate).format('YYYY-MM-DD')}
          </Descriptions.Item>
          <Descriptions.Item label="Company No">{member.companyno}</Descriptions.Item>
          <Descriptions.Item span={2} label="Profile">
            {member.profile}
          </Descriptions.Item>
        </Descriptions>
      </Row>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Button onClick={onShow} type="dashed" icon="user-add">
          Update Profile
        </Button>
        <EditModal
          visible={visible}
          handleCancel={() => {
            onCancel()
            fetch()
          }}
          member={member}
        />
      </Row>

      <EditModal
        visible={repVisible}
        handleCancel={() => {
          onCancelRep()
          fetch()
        }}
        member={get(rep, 'object', {})}
      />

      <Row style={{ marginTop: 50, marginLeft: 20 }}>
        <FormSectionTitle title={'Representatives'} padding={0} marginBottom={0}/>
        <CustomTable
          defaultPageSize={7}
          style={{}}
          data={uniqDataByPosition}
          fetching={fetching}
          fetch={fetch}
          columns={columns}
        />
      </Row>
    </Fragment>
  )
}

export default Profile
